import { defineComponent as a, computed as o, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "932b63ec-b016-4c36-abc2-5f3188f37b93" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#932b63ec-b016-4c36-abc2-5f3188f37b93)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "m0 144.7 255.3-36.5L512 144.7v222.6L250.5 407 0 367.3z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#ff9811",
  d: "M0 0h512v144.7H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M0 367.3h512V512H0z"
}, null, -1), x = /* @__PURE__ */ e("circle", {
  cx: "256",
  cy: "256.1",
  r: "89",
  fill: "#ff9811"
}, null, -1), b = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ a({
  __name: "ne",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (c(), i("title", k, d(t.flagName), 1)) : f("", !0),
        p,
        v,
        g,
        x
      ]),
      e("g", b, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=ne-5481e6fb.js.map
